'use-client';
import BreadcrumbsCore from './skinComps/Breadcrumbs.core';

export default BreadcrumbsCore;
